<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">REPORTE DE RECAUDOS</div>
    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td width="150px">
                <input
                  id="fechainicio"
                  placeholder="Fecha inicio"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td width="150px">
                <input
                  id="fechafin"
                  placeholder="Fecha final"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td>
                <button
                  class="btn btn-warning"
                  type="submit"
                  v-on:click="getReporteEquipos"
                >
                  Consultar
                </button>
              </td>
              <td>
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="containter-table" class="containter-table">
        <DataTable
          :columns="columns"
          :data="reporte"
          :options="options"
          class="display nowrap"
          style="width: 100%"
        />
      </div>
      <table width="300px" class="table font-oswald">
        <tbody>
          <tr>
            <td class="subtable" width="150px">TRANSACCIONES</td>
            <td class="subtable b text-right">
              {{ totalventas }}
            </td>
          </tr>
          <tr>
            <td class="subtable">TOTAL CANTIDAD</td>
            <td class="subtable b text-right">
              {{ fcantidad }}
            </td>
          </tr>
          <tr>
            <td class="subtable">TOTAL IMPUESTOS</td>
            <td class="subtable b text-right">
              {{ ftotalimpuestos }}
            </td>
          </tr>
          <tr>
            <td class="subtable">TOTAL VENTAS</td>
            <td class="subtable b text-right">
              {{ ftotales }}
            </td>
          </tr>
          <tr>
            <td class="subtable">TOTAL RECAUDADO</td>
            <td class="subtable b text-right">
              {{ GLOBAL.FORMATO_MONEY_BASIC(total_recaudos) }}
            </td>
          </tr>
          <tr>
            <td class="subtable">FECHA INICIO</td>
            <td class="subtable b text-right">
              {{ fecha_inicio_reporte }}
            </td>
          </tr>
          <tr>
            <td class="subtable">FECHA FINAL</td>
            <td class="subtable b text-right">
              {{ fecha_final_reporte }}
            </td>
          </tr>
        </tbody>
      </table>

      <div id="myModal" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Venta # {{ venta._id }}</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body bg-gray">
              <div class="bg-gray">
                <div class="bg-gray">
                  <FacturaPosView :key="facturaKey" :object="factura" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import VehiculoService from "../../views/Vehiculos/VehiculoService";
import FacturaPosView from "../../components/FacturaPosView.vue";

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net";
import Buttons from "datatables.net-buttons";
import ButtonsHtml5 from "datatables.net-buttons/js/buttons.html5";

DataTable.use(DataTablesCore);
DataTable.use(Buttons);
DataTable.use(ButtonsHtml5);

export default {
  components: { DataTable, FacturaPosView },
  data() {
    return {
      GLOBAL,
      table: null,
      reporteService: null,
      person: null,
      permiso_lista: false,
      reporte: [],
      totalventas: 0,
      totalimpuestos: 0,
      totales: 0,
      total_recaudos: 0,
      ftotalimpuestos: "$ 0",
      ftotales: "$ 0",
      totalCantidad: 0,
      fcantidad: "0",
      fecha_inicio_reporte: "",
      fecha_final_reporte: "",
      venta: [],
      facturaKey: 0,
      factura: [],
      loading: true,
      columns: [
        { title: "Fecha", data: "fecha" },
        { title: "EDS", data: "eds" },
        { title: "Consecutivo", data: "consecutivo" },
        { title: "Placa", data: "placa", class: "text-center" },
        { title: "Productos", data: "producto", class: "text-center" },
        {
          title: "Recaudar",
          class: "text-center",
          data: "recaudar",
          class: "text-center",
        },
        {
          title: "Cantidad",
          class: "text-center",
          data: "cantidad",
          class: "text-center",
        },
        {
          title: "Unidad",
          class: "text-center",
          data: "unidad",
          class: "text-center",
        },
        {
          title: "Precio",
          class: "text-center",
          data: "precio",
          class: "text-center",
        },
        {
          title: "Venta",
          class: "text-center",
          data: "venta",
          class: "text-center",
        },
        {
          title: "Recaudado",
          class: "text-center",
          data: "recaudado",
          class: "text-center",
        },
        {
          title: "Total",
          class: "text-center",
          data: "total_final",
          class: "text-center",
        },
        {
          data: null,
          sortable: false,
          render: function (data, type, full, meta) {
            var buttonID = full.item;
            if (full.documento != 27) {
              return "";
              //return '<button class="btn btn-sm btn-info" data-id="' + buttonID + '" id="edit"><i class="fa-solid fa-receipt"></i></button>';
            } else {
              return "";
            }
          },
        },
      ],
      options: {
        ...GLOBAL.TABLE_OPTIONS,
        createdRow: function (row, data, dataIndex) {
          const vueInstance = this;
        }.bind(this),
      },
    };
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.reporteService = new VehiculoService();

    this.factura = {};
    this.factura.empresa = {};
    this.factura.consecutivo = {};
    this.factura.origen = {};
    this.factura.promotor = {};
    this.factura.invoiceTaxExclusiveTotal = 0.0;
  },
  mounted() {
    var fecha = new Date();
    $("#fechainicio").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate()) +
        " 00:00"
    );
    $("#fechafin").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate()) +
        " 23:59"
    );

    $("input[datatype='fecha']").datetimepicker();
    this.table = $("#containter-table").html();

    this.getReporteEquipos();
  },
  methods: {
    refrescarFactura() {
      this.facturaKey += 1;
    },
    getReporteEquipos() {
      this.reporte = [];

      var fechainicio = $("#fechainicio").val();
      var fechafin = $("#fechafin").val();
      this.loading = true;
      this.reporteService
        .getReporteRecaudos(this.person, fechainicio, fechafin)
        .then((json) => {
          var data = json.data;
          console.log(data);
          this.totalventas = 0;
          this.totalCantidad = 0;
          this.totaleds = 0;

          this.totalimpuestos = 0;
          this.totales = 0;

          var x = 0;
          for (const i in data) {
            this.reporte[i] = [];
            this.reporte[i].fecha = data[i].fecha;
            this.reporte[i].eds = data[i].eds;
            this.reporte[i].consecutivo =
              data[i].prefijo + "-" + data[i].consecutivo;
            this.reporte[i].placa = data[i].placa;
            this.reporte[i].producto = data[i].producto_nombre;
            this.reporte[i].recaudar = GLOBAL.FORMATO_MONEY_BASIC(
              data[i].recaudar
            );
            this.reporte[i].cantidad = data[i].cantidad;
            this.reporte[i].unidad = data[i].unidad_codigo;
            this.reporte[i].precio = GLOBAL.FORMATO_MONEY_BASIC(data[i].precio);
            this.reporte[i].venta = GLOBAL.FORMATO_MONEY_BASIC(data[i].venta);
            this.reporte[i].recaudado = GLOBAL.FORMATO_MONEY_BASIC(
              data[i].recaudado
            );
            this.reporte[i].total_final = GLOBAL.FORMATO_MONEY_BASIC(
              data[i].total_final
            );

            x++;
            this.totalventas = x;
            this.totalCantidad += data[i].cantidad;
            this.totalimpuestos += data[i].impuesto_total;
            this.totales += data[i].venta;
            this.total_recaudos += data[i].recaudado;
          }

          this.fcantidad = GLOBAL.FORMATO_NUMBER(this.totalCantidad);
          this.ftotalimpuestos = GLOBAL.FORMATO_MONEY(this.totalimpuestos);
          this.ftotales = GLOBAL.FORMATO_MONEY(this.totales);
          this.fecha_inicio_reporte = fechainicio;
          this.fecha_final_reporte = fechafin;
          this.loading = false;
        });
    },
  },
};
</script>
